import { InjectionToken } from '@angular/core';

/**
 * Where an auth service sends a signed-out visitor. Each app provides its own value (the company
 * app and the candidate account use `['/login']`; the portal has no login route at all). The
 * default is the shared shape every auth screen should adopt.
 */
export const AUTH_LOGIN_ROUTE = new InjectionToken<string[]>('RK_AUTH_LOGIN_ROUTE', {
  providedIn: 'root',
  factory: () => ['/login'],
});